import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-4" }

import { debounce } from "lodash-es";
import { ref, watchEffect, computed } from "vue";
import { useI18n } from "vue-i18n";

import { baseInput, baseSelect, baseTextarea } from "@/common/components";

import { EquipmentType } from "@/common/types/equipment";
import { ItemStatusEnum, EquipmentEnum } from "@/common/types/enum";


export default /*@__PURE__*/_defineComponent({
  __name: 'equipment',
  props: {
    data: {},
    title: {},
    width: { default: "100%" },
    isPatch: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t, tm } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_PAYLOAD = {
  code: "",
  description: null,
  status: ItemStatusEnum.AVAILABLE,
  type: EquipmentEnum.EQUIPMENT,
  name: "",
};

const payload = ref<Partial<EquipmentType>>({ ...DEFAULT_PAYLOAD });

const available = computed(
  () => tm("enums.item_status") as Record<string, string>
);

const types = computed(
  () => tm("enums.equipment_type") as Record<string, string>
);

const statusOptions = computed(() => [
  {
    option: available.value[ItemStatusEnum.AVAILABLE],
    value: ItemStatusEnum.AVAILABLE,
  },
  {
    option: available.value[ItemStatusEnum.RESERVED],
    value: ItemStatusEnum.RESERVED,
  },
  {
    option: available.value[ItemStatusEnum.IN_USE],
    value: ItemStatusEnum.IN_USE,
  },
  {
    option: available.value[ItemStatusEnum.UNAVAILABLE],
    value: ItemStatusEnum.UNAVAILABLE,
  },
  {
    option: available.value[ItemStatusEnum.BROKEN],
    value: ItemStatusEnum.BROKEN,
  },
]);

const typeOptions = computed(() => [
  {
    option: types.value[EquipmentEnum.EQUIPMENT],
    value: EquipmentEnum.EQUIPMENT,
  },
  {
    option: types.value[EquipmentEnum.ACCESSORY],
    value: EquipmentEnum.ACCESSORY,
  },
]);

function maskCode(value: string) {
  return value?.replaceAll(" ", "-")?.toUpperCase();
}

function update(key: keyof typeof payload.value) {
  if (props.isPatch)
    emit("update-data", { [key]: payload.value[key] });
  else
    emit("update-data", payload.value);
}

const debounceForm = debounce(update, 1000);

watchEffect(() => {
  if (props.data) {
    payload.value = {
      ...DEFAULT_PAYLOAD,
      ...props.data,
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "form-content",
    style: _normalizeStyle({ width: __props.width })
  }, [
    _createElementVNode("form", null, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.code) = $event)),
        value: payload.value.code,
        placeholder: _unref(t)('common.placeholders.code'),
        mask: maskCode,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(debounceForm)('code')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.code")) + " * ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref(debounceForm)('name')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " * ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(baseSelect), {
          modelValue: payload.value.type,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.type) = $event)),
          value: payload.value.type,
          options: typeOptions.value,
          "is-empty": false,
          required: "",
          onChange: _cache[5] || (_cache[5] = ($event: any) => (update('type')))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")) + " * ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value", "options"]),
        _createVNode(_unref(baseSelect), {
          modelValue: payload.value.status,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.status) = $event)),
          value: payload.value.status,
          options: statusOptions.value,
          "is-empty": false,
          required: "",
          onChange: _cache[7] || (_cache[7] = ($event: any) => (update('status')))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.status")) + " * ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value", "options"])
      ]),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.description,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.description) = $event)),
        value: payload.value.description,
        placeholder: _unref(t)('common.placeholders.describe'),
        onInput: _cache[9] || (_cache[9] = ($event: any) => (_unref(debounceForm)('description')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ])
  ], 4))
}
}

})